import React, { useEffect, useState } from 'react'
import { HugoEventType, HugoState, HugoStateOutput, UseHugoState } from './types'
import { Plugin, RenderInput, Shader, Unit, useGPU } from './gpu'
import { useLocation } from 'react-router-dom';
import { useTTS } from './tts';

const useHugoState: UseHugoState = ({ television }) => {
  const resolution = {
    width: 34,
    height: 13,
  }
  const { say, cancel } = useTTS()
  const [render, tick , { setTick }] = useGPU(television || {
    tickRate: 60,
    resolution,
  })

  const [state, setState] = useState<HugoState>({
    output: [],
    shaders: [],
    plugins: []
  })

  const output: HugoStateOutput = (content: RenderInput, { shaders = [], plugins = [], append = true, tts = false, initalTick = 0} = {}) => {
      if (tts) say(content)
      setState(currentState => {
        if (shaders !== currentState.shaders) setTick(initalTick)
        return {
          ...currentState,
          shaders: Array.isArray(shaders) ? shaders : currentState.shaders,
          plugins: Array.isArray(plugins) ? plugins : currentState.plugins,
          output: append ? currentState.output.concat(content) : content,
        }
      })
  }

  const clear = () => {
    setState(currentState => {
      return {
        output: [],
        shaders: [],
        plugins: []
      }
    })
  }
  

  const addRow = (row: Unit[], tts: boolean = false) => {
    if (tts) say([row])
    setState(currentState => {
      return {
        ...currentState,
        output: currentState.output.concat([row]),
      }
    })
  }
  
  const replaceLastRow = (row: Unit[], tts: boolean = false) => {
    if (tts) say([row])
    setState(currentState => {
      return {
        ...currentState,
        output: currentState.output.slice(0, currentState.output.length - 1).concat([row]),
      }
    })
  }

  const setShaders = (shaders: Shader[]) => {
    setState(currentState => {
      if (shaders !== currentState.shaders) setTick(0)
      return {
        ...currentState,
        shaders: Array.isArray(shaders) ? shaders : currentState.shaders,
      }
    })
  }

  const setPlugins = (plugins: Plugin[]) => {
    setState(currentState => {
      return {
        ...currentState,
        plugins: Array.isArray(plugins) ? plugins : currentState.plugins,
      }
    })
  }

  const deleteRow = (index: number) => {
    setState(currentState => {
      let newOutput = [...currentState.output]
      newOutput.splice(index, 1)
      return {
        ...currentState,
        output: newOutput,
      }
    })
  }

  const cancleTTS = () => {
    cancel()
  }

  const addListener = (type: HugoEventType, listener: EventListener) => {
    document.addEventListener(type, listener)
  }

  const removeListener = (type: HugoEventType, listener: EventListener) => {
    document.removeEventListener(type, listener)
  }

  const getResolution = () => resolution

  const api = {
    output,
    addRow,
    replaceLastRow,
    deleteRow,
    setShaders,
    setPlugins,
    render,
    clear,
    cancleTTS,
    addListener,
    removeListener,
    getResolution,
    
  }


  return [
    state,
    api,
    tick,
  ]
}

export default useHugoState
